<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>

<div id="questionLists" class="col-md-10 mt-5">
  @for (staff of staffs; track staff) {
    <p class="pb-3">
      <strong>{{ staff.name }}</strong>
      <br />
      @if (staff.title) {
        <span
          >{{ staff.title }}
          <br />
        </span>
      }
      {{ staff.subTitle }}
      <br />
      <a href="{{ staff.url }}" target="_blank">{{ staff.email }}</a>
    </p>
  }

  @for (info of infos; track info) {
    <p>
      <strong>{{ info.name }}</strong>
      <br />
      {{ info.address1 }}
      <br />
      {{ info.address2 }}
      <br />
      <strong>Tel:</strong>
      {{ info.number }}
      <br />
      <strong>Email:&nbsp;</strong>
      <a href="{{ info.url }}" target="_blank">{{ info.email }}</a>
    </p>
  }
</div>
